export class FailedToDownloadLogoError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "FailedToDownloadLogoError"
    }
}

export class UnexpectedMimeTypeError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "UnexpectedMimeTypeError"
    }
}